import React from "react";
import "./Why2.css";
import bgImage from "../Why2/mask-img.webp"; // Replace with actual path
import { FaWallet } from "react-icons/fa";
import { Link } from "react-router-dom";

const Why2 = () => {
  return (
    <section className="why2-section">
      <div className="why2-left">
        <img src={bgImage} alt="Beach Villa" className="why2-image" />
      </div>

      <div className="why2-right">
        <p className="why2-subtitle">WHY CHOOSE US</p>
        <h1 className="why2-title">
          Why You Should Choose
          <br />
          Our Company
        </h1>
        <p className="why2-desc">
          Explore exceptional services tailored to your needs. Our experience,
          dedication, and personalized support set us apart.
        </p>

        <div className="why2-feature">
          <div className="why2-feature-icon">
            <FaWallet className="wallet-icon" />
          </div>
          <div>
            <h3 className="why2-feature-title">Best Price Guarantee</h3>
            <p className="why2-feature-text">
              Enjoy transparent pricing with no hidden fees. We ensure you
              always get the best value for your journey.
            </p>
          </div>
        </div>

        <div className="why2-stats">
          <div className="stat-box">
            <h2>30.3k</h2>
            <p>Happy Travelers</p>
          </div>
          <div className="stat-box">
            <h2>88.9%</h2>
            <p>Satisfaction Rate</p>
          </div>
        </div>
        <Link to="/aboutus">
          <button className="why2-button">Know More</button>
        </Link>
      </div>
    </section>
  );
};

export default Why2;
